import Activities from "./containers/Activities/Activities";
import AllActivities from "./containers/Activities/AllActivities";
import About from "./facades/About/About";
import Admin from "./facades/Admin/Admin";
import BibleYear from "./facades/BibleYear/BibleYear";
import BigBible from "./facades/BigBible/BigBible";
import Contact from "./facades/Contact/Contact";
import DailyBread from "./facades/DailyBread/DailyBread";
import E100 from "./facades/E100/E100";
import Home from "./facades/Home/Home";
import Hotshots from "./facades/Hotshots/Hotshots";
import Registration from "./facades/Registration/Registration";
import Support from "./facades/Support/Support";

export const ROUTES = [
  { path: "/", component: <Home /> },
  { path: "/about-us", component: <About /> },
  { path: "/daily-bread", component: <DailyBread /> },
  { path: "/registration", component: <Registration /> },
  { path: "/support-us", component: <Support /> },
  { path: "/big-bible", component: <BigBible /> },
  { path: "/hotshots", component: <Hotshots /> },
  { path: "/contact-us", component: <Contact /> },
  { path: "/e100", component: <E100 /> },
  { path: "/activities", component: <Activities /> },
  { path: "/all-activities", component: <AllActivities /> },
  { path: "/admin", component: <Admin /> },
  { path: "/bible-1-year", component: <BibleYear /> },
];
